import getMatrixType from "@secureo/common/utils/getMatrixType"
import { DispatchLockingSystemReducer, LockingSystemReducerState } from ".."

type SetCellValuePayload = Pick<LockingSystemReducerState, "matrix" | "matrixType">

export const setCellValues = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	cellValues: [number, number, boolean][],
) => {
	const updatedMatrix = [...reducerState.matrix]

	for (const [rowIndex, cellIndex, isSelected] of cellValues) {
		updatedMatrix[rowIndex][cellIndex] = isSelected
	}
	const matrixType = getMatrixType(updatedMatrix)

	const payload: SetCellValuePayload = {
		matrix: updatedMatrix,
		matrixType,
	}

	dispatch({
		type: "SET_CELL_VALUES",
		payload,
	})
}
